import ManualBillingDocumentVatRate from '@/generated/controls/manualBillingDocument/ManualBillingDocumentVatRate.vue';
import { EditFieldType, FieldInfo, getFormat } from '@/framework/base/components/FieldInfo';
import { defineComponent } from 'vue';

export default defineComponent({
  components: {},
  extends: ManualBillingDocumentVatRate,
  computed: {
    editFieldInfo(): FieldInfo {
      return new FieldInfo(
        this.ressource,
        EditFieldType.PERCENTAGE,
        2,
        this.mask,
        getFormat(''),
        this.focusValidator,
        this.liveValidator,
        this.theme,
      );
    },
  },
})
